import { useState } from 'react';
import Layout from '../../../Components/Layout/Layout';
import Button from 'react-bootstrap/Button';
import { useSearchParams } from 'react-router-dom';
import Toaster from '../../../Components/Toaster/Toaster';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';
import { useSettingNewPass } from '../apiEndpoints/commonApiEndpoints';

const NewPassword = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const type = searchParams.get('type');
  const token = localStorage.getItem('bttf_forget_token');
  const Toast = Toaster();
  const { register, handleSubmit } = useForm();
  const [passwordType, setPasswordType] = useState('password');
  const { mutate, isPending } = useSettingNewPass({ type });
  const onSubmit: SubmitHandler<any> = async (data: {
    confirm_password: string;
    password: string;
  }) => {
    if (data.password !== data.confirm_password) {
      Toast.fire({
        icon: 'error',
        title: 'Password does not match',
      });
      return;
    }
    if (data.password.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });

      return;
    }

    mutate({ email, token, password: data.password });
  };
  return (
    <>
      {' '}
      <Layout
        pathName={
          type === 'forget_fair'
            ? 'Exhibitor'
            : type === 'forget_b2b'
            ? 'Buyer/Seller B2B'
            : type === 'forget_visitor'
            ? 'Visitor'
            : ''
        }
        showHeader
      >
        <div className='login-wrapper'>
          <div className='login-div'>
            <div className='login-page'>
              <h3 className='text-center'>Set new password</h3>
              <div className='login-form'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <InputField
                      label='Enter new password'
                      register={register('password')}
                      type={passwordType}
                      isRequired
                      placeholder='Enter your password'
                    />
                  </div>
                  <div>
                    <InputField
                      label='Retype password'
                      register={register('confirm_password')}
                      type={passwordType}
                      isRequired
                      placeholder='Enter your confirm password'
                    />
                  </div>

                  <div className='d-flex align-items-center gap-2 pt-2'>
                    <input
                      type='checkbox'
                      onClick={(e: any) => {
                        if (e.target.checked) {
                          setPasswordType('text');
                        } else {
                          setPasswordType('password');
                        }
                      }}
                      id=''
                    />
                    <p>Show password</p>
                  </div>
                  <div>
                    {isPending ? (
                      <Loader css={'w-100 mt-5 text-white'} />
                    ) : (
                      <Button
                        type='submit'
                        className='w-100 mt-5 submit-button'
                      >
                        Submit
                      </Button>
                    )}
                  </div>

                  <div className='lost-your-password pt-3 fw-bold text-center'>
                    <Link to='/login' className='forget-link'>
                      Go back
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default NewPassword;
